/* ==========================================================
   V-HYDRA CREATORS • HERO
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const hero = document.querySelector("#vhc-hero");

    if (!hero) return;

    const inner = hero.querySelector(".vhc-hero__inner");
    const badge = hero.querySelector(".vhc-hero__badge");
    const title = hero.querySelector(".vhc-hero__title");
    const subtitle = hero.querySelector(".vhc-hero__subtitle");
    const actions = hero.querySelector(".vhc-hero__actions");
    const scroll = hero.querySelector(".vhc-hero__scroll");

    /* ============================================
       Estado inicial
    ============================================ */

    [badge, title, subtitle, actions].forEach(el => {

        if (!el) return;

        el.style.opacity = "0";
        el.style.transform = "translateY(28px)";
        el.style.transition =
            "opacity .8s ease, transform .8s cubic-bezier(.22,1,.36,1)";

    });

    requestAnimationFrame(() => {

        const sequence = [badge, title, subtitle, actions];

        sequence.forEach((el, index) => {

            if (!el) return;

            setTimeout(() => {

                el.style.opacity = "1";
                el.style.transform = "translateY(0)";

            }, index * 180);

        });

    });

    /* ============================================
       Scroll Indicator
    ============================================ */

    if (scroll) {

        scroll.addEventListener("click", () => {

            const next = hero.nextElementSibling;

            if (!next) return;

            next.scrollIntoView({

                behavior: "smooth",
                block: "start"

            });

        });

    }

    /* ============================================
       Fade do indicador ao rolar
    ============================================ */

    const toggleScroll = () => {

        if (!scroll) return;

        if (window.scrollY > 120) {

            scroll.style.opacity = "0";
            scroll.style.pointerEvents = "none";

        } else {

            scroll.style.opacity = "1";
            scroll.style.pointerEvents = "auto";

        }

    };

    toggleScroll();

    window.addEventListener("scroll", toggleScroll, { passive: true });

    /* ============================================
       Hover dos botões
    ============================================ */

    hero.querySelectorAll(".vhc-btn").forEach(btn => {

        btn.addEventListener("mouseenter", () => {

            btn.style.transform = "translateY(-3px) scale(1.02)";

        });

        btn.addEventListener("mouseleave", () => {

            btn.style.transform = "";

        });

    });

});
/* ==========================================================
   VHC TIMELINE
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const steps = document.querySelectorAll(".vhc-step");

    if (!steps.length) return;

    /* animação inicial */

    const reveal = new IntersectionObserver((entries)=>{

        entries.forEach(entry=>{

            if(entry.isIntersecting){

                entry.target.classList.add("is-visible");

            }

        });

    },{

        threshold:.15

    });

    steps.forEach(step=>reveal.observe(step));

    /* etapa ativa */

    function updateActive(){

        let current = null;

        steps.forEach(step=>{

            const rect = step.getBoundingClientRect();

            const center = window.innerHeight * .45;

            if(rect.top < center && rect.bottom > center){

                current = step;

            }

        });

        steps.forEach(step=>step.classList.remove("is-active"));

        if(current){

            current.classList.add("is-active");

        }

    }

    window.addEventListener("scroll",updateActive,{passive:true});

    window.addEventListener("resize",updateActive);

    updateActive();

});
/* ==========================================================
   VHC BENEFITS
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const benefits = document.querySelectorAll(".vhc-benefit");

    if (!benefits.length) return;

    const observer = new IntersectionObserver((entries)=>{

        entries.forEach(entry=>{

            if(entry.isIntersecting){

                entry.target.classList.add("is-visible");

            }

        });

    },{

        threshold:.18

    });

    benefits.forEach(card=>observer.observe(card));

    function updateActive(){

        let current = null;

        benefits.forEach(card=>{

            const rect = card.getBoundingClientRect();

            const center = window.innerHeight * .45;

            if(rect.top < center && rect.bottom > center){

                current = card;

            }

        });

        benefits.forEach(card=>card.classList.remove("is-active"));

        if(current){

            current.classList.add("is-active");

        }

    }

    window.addEventListener("scroll",updateActive,{passive:true});

    window.addEventListener("resize",updateActive);

    updateActive();

});
/* ==========================================================
   STARTER KIT SCROLL ACTIVE
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const cards = document.querySelectorAll(".vhc-starter-item");

    if (!cards.length) return;

    function updateActive(){

        let current = null;
        const trigger = window.innerHeight * 0.45;

        cards.forEach(card=>{

            const rect = card.getBoundingClientRect();

            if(rect.top < trigger && rect.bottom > trigger){

                current = card;

            }

        });

        cards.forEach(card=>card.classList.remove("is-active"));

        if(current){

            current.classList.add("is-active");

        }

    }

    window.addEventListener("scroll", updateActive, { passive:true });

    window.addEventListener("resize", updateActive);

    updateActive();

});
document.addEventListener("DOMContentLoaded", () => {

    const items = document.querySelectorAll(".vhc-starter-item");

    if (!items.length) return;

    function activateCard(){

        const middle = window.innerHeight * 0.45;

        let active = null;

        items.forEach(item => {

            const rect = item.getBoundingClientRect();

            if(rect.top <= middle && rect.bottom >= middle){

                active = item;

            }

        });

        items.forEach(item => item.classList.remove("is-active"));

        if(active){

            active.classList.add("is-active");

        }

    }

    window.addEventListener("scroll", activateCard, { passive:true });

    window.addEventListener("resize", activateCard);

    activateCard();

});